import React from 'react';
import "./usersAdd.css"
import UsersInputs from './inputs/usersInputs';

const UsersAdd = (props) => {
    return ( 
        <>
            <div className="mainUsersList">
                <h1 className="usersTitle">Dodaj Uzytkownika</h1>
                <UsersInputs
                    companiesList = {props.companiesList}
                    actualUserName = {props.actualUserName}
                    actualUserMail = {props.actualUserMail}
                    actualUserPhone = {props.actualUserPhone}
                    actualUserType = {props.actualUserType}
                    actualUserCompanyID = {props.actualUserCompanyID}
                    actualUserPassword = {props.actualUserPassword}
                    handleActualUserNameChange = {props.handleActualUserNameChange}
                    handleActualUserMailChange = {props.handleActualUserMailChange}
                    handleActualUserPhoneChange = {props.handleActualUserPhoneChange}
                    handleActualUserTypeChange = {props.handleActualUserTypeChange}
                    handleActualUserCompanyIDChange = {props.handleActualUserCompanyIDChange}
                    handleActualUserPasswordChange = {props.handleActualUserPasswordChange}
                    handleAddUser = {props.handleAddUser}
                />
            </div>
        </>
     );
}
 
export default UsersAdd;